import './PartnersController.scss';

export class PartnersController {
    static instance = [PartnersController];

    static template = require('./PartnersController.html');
}